import React, { useContext, useEffect, Suspense } from "react";
import { useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const Ticket = React.lazy(() => import("../../components/Ticket/"));
const MobileTicketsManager = React.lazy(() => import("../../components/MobileTicketsManager/"));

const TicketAdvanced = () => {
  const { ticketId } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { currentTicket, setCurrentTicket } = useContext(TicketsContext);

  useEffect(() => {
    if (currentTicket.id !== null) {
      setCurrentTicket({ id: currentTicket.id, code: "#open" });
    }
    return () => setCurrentTicket({ id: null, code: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <QueueSelectedProvider>
      <Box style={{
        width: isMobile ? "100vw" : "100%",
        height: isMobile ? (ticketId && ticketId !== "undefined" ? "100dvh" : "calc(100dvh - 64px)") : "100%",
        overflow: "hidden",
        background: "#fff",
        // Keep the mobile workspace above navigation, but below portaled menus/dialogs.
        ...(isMobile ? { position: "fixed", top: ticketId && ticketId !== "undefined" ? 0 : 64, left: 0, right: 0, bottom: 0, zIndex: theme.zIndex.appBar } : {})
      }}>
        {ticketId && ticketId !== "undefined" ? (
          <Suspense fallback={<Box display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress /></Box>}>
            <Ticket />
          </Suspense>
        ) : (
          <Suspense fallback={<Box display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress /></Box>}>
            <MobileTicketsManager />
          </Suspense>
        )}
      </Box>
    </QueueSelectedProvider>
  );
};

export default TicketAdvanced;
